export default "__VITE_ASSET__CmrDew2t__"